import type { BrandConfig } from '@portals-platform/brand-kit';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

const BrandConfigContext = createContext<BrandConfig | null>(null);

export function BrandConfigProvider({
  config,
  children,
}: {
  config: BrandConfig;
  children: ReactNode;
}) {
  return <BrandConfigContext.Provider value={config}>{children}</BrandConfigContext.Provider>;
}

export function useBrandConfig(): BrandConfig {
  const ctx = useContext(BrandConfigContext);
  if (!ctx) throw new Error('useBrandConfig must be used inside BrandConfigProvider');
  return ctx;
}

/** Derive short initials from a brand name, e.g. "Price Forbes" → "PF", "Brinks" → "B" */
export function brandInitials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('')
    .slice(0, 2);
}
